// series/show: one panel per year, the current year starts open
import $ from 'jquery';

$(() => {
  const $panels = $('.panel-accordion');
  if ($panels.length === 0) {
    return;
  }

  $panels.not('.currentyear').slideUp();
  $('.accordion').on('click', function () {
    const $container = $(this).parents('.race_container');

    $(this).children('.panel-accordion').removeClass('currentyear');
    if ($container.is('.active')) {
      $container.removeClass('active');
      $panels.slideUp('200');
      return undefined;
    }
    $panels.slideUp('slow');
    $('.accordion').parents('.race_container').removeClass('active');
    $container.addClass('active');
    $(this).next('.panel-accordion').slideDown('200');
    return false;
  });
});
